import React, { createContext, useState, useContext, useEffect } from 'react';
import { playSound, stopAllSounds } from '../utils/sound';

const SoundContext = createContext();

export const useSoundContext = () => {
	const context = useContext(SoundContext);
	if (!context) {
		throw new Error('useSoundContext must be used within a SoundProvider');
	}
	return context;
};

export const SoundProvider = ({ children }) => {
	const [isSoundEnabled, setIsSoundEnabled] = useState(() => {
		const saved = localStorage.getItem('isSoundEnabled');
		return saved !== null ? JSON.parse(saved) : true;
	});

	useEffect(() => {
		localStorage.setItem('isSoundEnabled', JSON.stringify(isSoundEnabled));
		if (!isSoundEnabled) {
			stopAllSounds();
		}
	}, [isSoundEnabled]);

	const toggleSound = () => {
		setIsSoundEnabled(prev => !prev);
		playSound('sell', true); // Используем звук sell для переключения
	};

	const play = (soundName) => {
		playSound(soundName, isSoundEnabled);
	};

	return (
		<SoundContext.Provider value={{ isSoundEnabled, toggleSound, play }}>
			{children}
		</SoundContext.Provider>
	);
};

export default SoundContext; 